import {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
} from "./actionTypes";
import AuthService from "services/AuthService";

export const login = (username, password) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const resp = await AuthService.login(username, password);
      localStorage.setItem("access_token", resp.jwt);
      return dispatch(loginSuccess(resp.jwt));
    } catch (error) {
      return dispatch(loginFailure(error));
    }
  };
};

const loginBegin = () => ({
  type: LOGIN_BEGIN,
});

const loginSuccess = (jwt) => {
  return {
    type: LOGIN_SUCCESS,
    payload: { jwt },
  };
};

const loginFailure = (error) => {
  console.error(error);
  return {
    type: LOGIN_FAILURE,
    payload: { error },
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    localStorage.removeItem("access_token");
    try {
      await AuthService.logout();
      return dispatch(logoutSuccess());
    } catch (error) {
      return dispatch(logoutFailure(error));
    }
  };
};

const logoutBegin = (username, password) => ({
  type: LOGOUT_BEGIN,
  payload: { username, password },
});

const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

const logoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  payload: { error },
});
